import de from "vuetify/es5/locale/de";
import CKEditor from 'ckeditor4-vue';
/**
 * First, we will load all of this project's Javascript utilities and other
 * dependencies. Then, we will be ready to develop a robust and powerful
 * application frontend using useful Laravel and JavaScript libraries.
 */

require('./bootstrap');

//IE11/Safari9 Support
import '@babel/polyfill'

window.Vue = require('vue');

import Lang from 'lang.js'
import messages from './messages'

const lang = new Lang({messages});
const _ = require('lodash');
const moment = require('moment');

moment.locale("de")

Vue.use( CKEditor );

Object.defineProperty(Vue.prototype, '_', {value: _});
Object.defineProperty(Vue.prototype, '$moment', {value: moment});
Object.defineProperty(Vue.prototype, '__', {
    value: (key) => {
        return lang.get(key)
    }
});

window.Vuex = require('vuex');
Vue.use(Vuex);

import VueCurrencyInput from 'vue-currency-input'
Vue.use(VueCurrencyInput, {});

import Validation from './components/plugins/Validation.js';
Vue.use(Validation);

import Vuetify from 'vuetify';
Vue.use(Vuetify, {
    theme:
        {
            primary: '#ef7500',
            secondary: '#0163A4',
            accent: '#0163A4',
        },
    lang: {
        locales: {de},
        current: 'de'
    }
});

Vue.component('s-text-field', require('./components/TextField.vue').default);
Vue.component('s-switch', require('./components/Switch.vue').default);
Vue.component('s-textarea', require('./components/TextArea.vue').default);
Vue.component('s-number-field', require('./components/NumberField.vue').default);
Vue.component('s-currency-field', require('./components/CurrencyField.vue').default);
Vue.component('s-select', require('./components/Select.vue').default);
Vue.component('s-multi-select', require('./components/MultiSelect.vue').default);
Vue.component('s-editor', require('./components/Editor.vue').default);
Vue.component('s-email-field', require('./components/EmailField.vue').default);
Vue.component('success-snackbar', require('./components/SuccessSnackbar.vue').default);
Vue.component('failure-snackbar', require('./components/FailureSnackbar.vue').default);
Vue.component('s-date-range-picker', require('./components/DateRangePicker.vue').default);
Vue.component('date-picker', require('./components/DatePicker.vue').default);

